import { render, staticRenderFns } from "./Energy.vue?vue&type=template&id=04d81312&scoped=true"
import script from "./Energy.vue?vue&type=script&lang=js"
export * from "./Energy.vue?vue&type=script&lang=js"
import style0 from "./Energy.vue?vue&type=style&index=0&id=04d81312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d81312",
  null
  
)

export default component.exports